import { storeMixin, storeGenerator } from '@/storeMixin'
import { merge } from 'lodash'

const phonetypology = merge(storeMixin.getMixin(), {
  state: {
    apiUrl: '/api/v1/organization/{profile}/phone-typology',
    app: 'organization'
  }
})

const TYPES = (() =>
  merge(
    storeGenerator(
      { profile: 'GENERIC', app: 'organization', model: 'phonetypology' }
    ),
    { }
  )
)()

export { phonetypology, TYPES }
